import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { PageHero } from "../components/Section";
import { useApp } from "../context/AppContext";
import { useReveal } from "../hooks/useReveal";
import { regionsData } from "../data/regionsData";
import { IMAGES } from "../data/mock";
import { MapPin, ArrowRight } from "lucide-react";

const Regions = () => {
  const { t, lang } = useApp();
  useReveal();
  return (
    <div className="pt-20 bg-cream min-h-screen">
      <Seo title={t("regions.title")} description={t("regions.sub")} image={IMAGES.vineyard1} path="/regions" lang={lang} />
      <PageHero title={t("regions.title")} subtitle={t("regions.sub")} image={IMAGES.vineyard1} />
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
        {regionsData.map((r) => (
          <Link key={r.id} to={`/regions/${r.id}`} className="reveal group relative rounded-2xl overflow-hidden h-80 shadow-md block">
            <img src={r.img} alt={lang === "de" ? r.name : r.nameEn} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/30 to-transparent" />
            <div className="absolute bottom-0 p-6 text-cream">
              <p className="flex items-center gap-1.5 text-xs text-gold uppercase tracking-wider"><MapPin className="w-3.5 h-3.5" /> {r.subregions.length} {lang === "de" ? "Unterregionen" : "sub-regions"}</p>
              <h3 className="font-serif text-2xl mt-1">{lang === "de" ? r.name : r.nameEn}</h3>
              <p className="text-cream/75 text-sm mt-2 leading-relaxed line-clamp-2">{r.intro[lang]}</p>
              <span className="inline-flex items-center gap-1.5 mt-3 text-gold text-sm font-medium">{t("common.learnMore")} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Regions;
